/* Zevorah card swatches: hover swaps the card image to the variant image. */
(function () {
  if (window.lnSwatchesInit) return;
  window.lnSwatchesInit = true;
  function img(sw) {
    var card = sw.closest('.ln-card');
    return card && card.querySelector('.card__media .media img');
  }
  /* Preload a card's variant images as soon as the pointer or a finger reaches the card, so the swap on a
     swatch is instant instead of waiting for a 533px image that was never requested. Once per card. */
  function warm(e) {
    var card = e.target.closest && e.target.closest('.ln-card');
    if (!card || card.dataset.lnWarm) return;
    card.dataset.lnWarm = '1';
    card.querySelectorAll('.ln-swatch[data-variant-image]').forEach(function (sw) { var i = new Image(); i.src = sw.dataset.variantImage; });
  }
  document.addEventListener('pointerover', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.ln-swatch[data-variant-image]');
    if (!sw) return;
    var el = img(sw);
    if (!el) return;
    if (!el.dataset.lnSrc) { el.dataset.lnSrc = el.getAttribute('src'); el.dataset.lnSrcset = el.getAttribute('srcset') || ''; }
    el.removeAttribute('srcset');
    el.setAttribute('src', sw.dataset.variantImage);
    sw.closest('.ln-card').classList.add('ln-card--swatch');
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('.ln-swatch[data-variant-image]');
    if (!sw || (e.relatedTarget && sw.contains(e.relatedTarget))) return;
    var el = img(sw);
    if (!el || !el.dataset.lnSrc) return;
    el.setAttribute('src', el.dataset.lnSrc);
    if (el.dataset.lnSrcset) el.setAttribute('srcset', el.dataset.lnSrcset);
    sw.closest('.ln-card').classList.remove('ln-card--swatch');
  });
})();
  
